(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["checkout-button"] && !Shopify.designMode) return;
  try {
    (() => {
    const observedParents = new WeakSet();
    let globalObserverBound = false;

    const ensureCheckoutButtonIsLast = (scope = document) => {
      const wrappers = scope.querySelectorAll('[data-checkout-button-block]');

      wrappers.forEach((wrapper) => {
        const parent = wrapper.closest('.product-form-buttons');
        if (!parent) return;

        if (parent.lastElementChild !== wrapper) {
          parent.appendChild(wrapper);
        }

        if (observedParents.has(parent)) return;

        const observer = new MutationObserver(() => {
          if (parent.lastElementChild !== wrapper) {
            parent.appendChild(wrapper);
          }
        });

        observer.observe(parent, { childList: true });
        observedParents.add(parent);
      });
    };

    const bindCheckoutButtonHandlers = (scope = document) => {
      const checkoutButtons = scope.querySelectorAll('.checkout-button');

      checkoutButtons.forEach((button) => {
        if (button.dataset.checkoutHandlerBound === 'true') return;

        button.dataset.checkoutHandlerBound = 'true';
        button.addEventListener('click', async function (e) {
          e.preventDefault();

          if (this.disabled) return;

          this.disabled = true;
          this.textContent = this.dataset.addingText;

          try {
            const form = this.closest('form');
            if (!form) throw new Error('Checkout button is not inside a product form.');

            const formData = new FormData(form);
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            });

            if (response.ok) {
              window.location.href = '/checkout';
            } else {
              console.error('Failed to add to cart');
              this.disabled = false;
              this.textContent = this.dataset.originalText;
            }
          } catch (error) {
            console.error('Error adding to cart:', error);
            this.disabled = false;
            this.textContent = this.dataset.originalText;
          }
        });
      });
    };

    const initCheckoutButtons = (scope = document) => {
      ensureCheckoutButtonIsLast(scope);
      bindCheckoutButtonHandlers(scope);
    };

    const bindGlobalObserver = () => {
      if (globalObserverBound || !document.body) return;

      const globalObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type !== 'childList') continue;
          if (mutation.addedNodes.length === 0 && mutation.removedNodes.length === 0) continue;

          initCheckoutButtons();
          break;
        }
      });

      globalObserver.observe(document.body, {
        childList: true,
        subtree: true
      });

      globalObserverBound = true;
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initCheckoutButtons();
        bindGlobalObserver();
      });
    } else {
      initCheckoutButtons();
      bindGlobalObserver();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initCheckoutButtons(event.target instanceof Element ? event.target : document);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
